import { render, staticRenderFns } from "./EditProductForm.vue?vue&type=template&id=4771a08d&scoped=true"
import script from "./EditProductForm.vue?vue&type=script&lang=js"
export * from "./EditProductForm.vue?vue&type=script&lang=js"
import style0 from "./EditProductForm.vue?vue&type=style&index=0&id=4771a08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771a08d",
  null
  
)

export default component.exports